import React from 'react';
import {connect} from 'react-redux';
import {NavLink} from 'react-router-dom';
import {bindActionCreators} from "redux";

import {createUserIgnored, deleteUserIgnored} from "../../../../creators/user.userIgnored";
import {updateCurrentUser} from "../../../../creators/currentUser";

import Dropdown from '../../../components/Dropdown';
import Avatar from '../../../components/Avatar';
import Report from '../../../components/Report';
import Icon from '../../../components/Icon';
import {Button} from "../../../components/Button";
import Alert from "../../../components/Alert";
import {coverDefault} from '../../../../config';
import coverMan from "../../../../images/covers/man.jpg";
import coverWoman from "../../../../images/covers/woman.jpg";
import coverCouple from "../../../../images/covers/couple.jpg";
import Modal from "../../../components/Modal";
import createLink from '../../../../libs/createLink';
import UploaderAC from "../../../components/upload/UploadAC";
import {reportUser} from "../../../../creators/report";
import {Can} from "../../../../ability-context"
import _ from "lodash";
import {Breakpoint} from "../../../../libs/breakpoint";

const coverGender = (gender)=>{
    if(gender === 1){
        return coverMan;
    }
    else if(gender === 2){
        return coverWoman;
    }
    else if(gender === 3){
        return coverCouple;
    }
    else{
        return coverDefault
    }
}

class ProfileHeader extends React.Component {
    constructor(props) {
        super(props);
        let user = _.get(this.props,"user") || {};
        this.state = {
            userAvatar : _.get(this.props,"user.profile.avatar") || "",
            user: user,
            toggleChangePicture: false,
            uploadAvatar: false,
            uploadCover: false,
            type: '',
            isBanned: false,
            toggleAlertHandleDeleteAvatar: false,
            toggleAlertHandleDeleteCover: false,
            showQuestion: false,
            isIgnored : this.props.currentUser.usersIgnored && this.props.currentUser.usersIgnored.includes(user._id)
        };
        this.handleAddIgnoredUser = this.handleAddIgnoredUser.bind(this);
        this.handleRemoveIgnoredUser = this.handleRemoveIgnoredUser.bind(this);
        this.handleReport = this.handleReport.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        if(this.props.onRef){
            this.props.onRef(this)
        }

    }

    componentWillUnmount() {
        if(this.props.onRef) {
            this.props.onRef(undefined)
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.userIgnored.update !== this.props.userIgnored.update) {
            if (this.props.userIgnored.update === "ok") {
                this.props.history.push("/");
            } else {
                //console.log("error")
            }
        }
    }

    handleAddIgnoredUser(userId) {
        this.props.createUserIgnored(userId);
        this.setState({isIgnored : true});
    }

    handleRemoveIgnoredUser(userId) {
        this.props.deleteUserIgnored(userId);
        this.setState({isIgnored : false});
    }

    handleDelete(imgType) {
        // this.props.removeImage(imgType);
        if (imgType === "avatar") {
            this.props.updateCurrentUser({profile : {avatarId : ""}});
            this.setState({toggleAlertHandleDeleteAvatar: false});
        } else {
            this.props.updateCurrentUser({profile : {coverId : "",}});
            this.setState({toggleAlertHandleDeleteCover: false});
        }
    }

    handleReport(message){
        this.props.reportUser(this.props.user._id, {message})
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.props.user !== nextProps.user){
            return true;
        }
        if(this.state !== nextState){
            return true;
        }
        return false
    }


    render() {
        let userId = this.props.user._id || 0;


        // let breadCrumbsData = [{
        //     name : this.props.user.username,
        //     link : canonical(createLink('userProfile', this.props.user)),
        //     to : createLink('userProfile', this.props.user),
        // }];
        return (
            <div className="profil-header">
                <Modal toggle={this.state.uploadAvatar}
                       handleClose={() => this.setState({uploadAvatar: false})}>
                    <UploaderAC type={"avatar"}
                                uploadPath={"/users/me/upload-avatar"}
                                handleClose={() => this.setState({uploadAvatar: false})}/>
                </Modal>
                <Modal toggle={this.state.uploadCover}
                       handleClose={() => this.setState({uploadCover: false})}>
                    <UploaderAC type={"cover"}
                                uploadPath={"/users/me/upload-cover"}
                                handleClose={() => this.setState({uploadCover: false})}/>
                </Modal>
                <Modal toggle={this.state.toggleAlertHandleDeleteCover}
                       handleClose={() => this.setState({toggleAlertHandleDeleteCover: false})}>
                    <Alert text={"Voulez-vous vraiment supprimer votre image ?"}
                           handleClose={() => this.setState({toggleAlertHandleDeleteCover: false})}
                           handleDelete={() => this.handleDelete("cover")}/>
                </Modal>
                <Modal toggle={this.state.toggleAlertHandleDeleteAvatar}
                       handleClose={() => this.setState({toggleAlertHandleDeleteAvatar: false})}>
                    <Alert text={"Voulez-vous vraiment supprimer votre image ?"}
                           handleClose={() => this.setState({toggleAlertHandleDeleteAvatar: false})}
                           handleDelete={() => this.handleDelete("avatar")}/>
                </Modal>
                <div className="wrapper-profil-header-couv" style={this.props.user._id ? {
                    background: `url(${_.get(this.props, 'user.profile.cover') || coverGender(this.props.user.profile.gender)}?width=1180&height=300) no-repeat center #E9E9E9`,
                    backgroundSize: 'cover'
                } : {background: `#E9E9E9`, backgroundSize: 'cover'}}>
                    {this.props.isMe && (<div className="btn-change-bg">
                        <Dropdown align="right" activableComponent={(
                            <Button className={"camera-icon"}
                                    size={"small"}
                                    icon={"camera"}/>
                        )}>
                            <ul className="dropdown-menu">
                                <li className="menu-item"
                                    onClick={() => this.setState({uploadCover: true, type: 'cover'})}>
                                    Télécharger une photo
                                </li>
                                {this.props.user.profile.coverId && (
                                    <li className="menu-item cancel"
                                        onClick={() => this.setState({toggleAlertHandleDeleteCover: true})}>Supprimer la
                                        photo</li>
                                )}
                            </ul>
                        </Dropdown>
                    </div>)}
                </div>
                <div className="wrapper-profil-navbar">
                    <div className="profil-user-wrapper">
                        <div className="thumb-user-informations">
                            <Avatar
                                width={150}
                                height={150}
                                avatar={_.get(this.props, 'user.profile.avatar')}
                                gender={_.get(this.props, 'user.profile.gender')}
                                alt={`avatar de ${this.props.user.username}`}/>
                            {this.props.isMe && (
                                <div className="btn-change-picture">
                                    <Dropdown align="right" activableComponent={(
                                        <Button className={"camera-icon"}
                                                size={"small"}
                                                icon={"camera"}/>
                                    )}>
                                        <ul className="dropdown-menu">
                                            <li className="menu-item" onClick={() => this.setState({
                                                uploadAvatar: true,
                                                type: 'avatar'
                                            })}>
                                                Télécharger la photo
                                            </li>
                                            {/*<li className="menu-item" onClick={() => this.setState({*/}
                                            {/*    toggleChangePicture: true,*/}
                                            {/*    type: 'avatar'*/}
                                            {/*})}>*/}
                                            {/*    Changer la photo*/}
                                            {/*</li>*/}
                                            {this.props.user.profile.avatar !== "" ? (
                                                <li className="menu-item cancel"
                                                    onClick={() => this.setState({toggleAlertHandleDeleteAvatar: true})}>
                                                    Supprimer la photo
                                                </li>
                                            ) : ''}
                                        </ul>
                                    </Dropdown>
                                </div>
                            )}
                        </div>
                        <div className="user-informations">
                            <span className="username">{this.props.user.username} {this.state.isIgnored && <span className="username-state">bloqué</span>}</span>
                            {this.props.user.isCertified && (
                                <div className="certified"><Icon type="certificate"/> Membre certifié</div>
                            )}
                        </div>
                    </div>
                    <Breakpoint sizeBelow="sm">
                        <ul className="profil-navbar">
                            <li>
                                <NavLink exact className="link" activeClassName="active"
                                         to={this.props.isMe ? createLink('userMe', this.props.user) : createLink('userProfile', this.props.user)+"#profil-page"}>Fil d'actualité</NavLink>
                            </li>
                            {_.get(this.props.user,"setting.appearInDating") && (
                                <li><NavLink className="link" activeClassName="active"
                                             to={this.props.isMe ? createLink('userMeDating', this.props.user) : createLink('userDating', this.props.user)+"#profil-page"}
                                             rel={"nofollow"}>Rencontre</NavLink>
                                </li>
                            )}
                            <li>
                                <NavLink className="link" activeClassName="active"
                                         to={this.props.isMe ? createLink('userMeAlbums', this.props.user) : createLink('userAlbums', this.props.user)+"#profil-page"}>Albums</NavLink>
                            </li>
                            <Can action="profile-medias" subject="Media">
                                <li><NavLink exact className="link" activeClassName="active"
                                             to={createLink('userMedias', this.props.user)}>Médias</NavLink></li>
                            </Can>
                            <li>
                                <NavLink className="link" activeClassName="active"
                                         to={this.props.isMe ? createLink('userMeArticles', this.props.user) : createLink('userArticles', this.props.user)+"#profil-page"}>Articles</NavLink>
                            </li>
                        </ul>
                    </Breakpoint>
                    <Breakpoint sizeAbove="sm" >
                        <ul className="profil-navbar">
                            <li>
                                <NavLink exact className="link" activeClassName="active"
                                         to={this.props.isMe ? createLink('userMe', this.props.user) : createLink('userProfile', this.props.user)}>Fil d'actualité</NavLink>
                            </li>

                            <li><NavLink className="link" activeClassName="active"
                                         to={this.props.isMe ? createLink('userMeDating', this.props.user) : createLink('userDating', this.props.user)}
                                         rel={"nofollow"}>Me rencontrer</NavLink>
                            </li>

                            <li>
                                <NavLink className="link" activeClassName="active"
                                         to={this.props.isMe ? createLink('userMeAlbums', this.props.user) : createLink('userAlbums', this.props.user)}>Albums</NavLink>
                            </li>
                            <Can action="profile-medias" subject="Media">
                                <li><NavLink exact className="link" activeClassName="active"
                                             to={createLink('userMedias', this.props.user)}>Médias</NavLink></li>
                            </Can>
                            <li>
                                <NavLink className="link" activeClassName="active"
                                         to={this.props.isMe ? createLink('userMeArticles', this.props.user) : createLink('userArticles', this.props.user)}>Articles</NavLink>
                            </li>
                        </ul>
                    </Breakpoint>
                    {!this.props.isMe && (
                        <Can action={"create"} subject="Reporting">
                            <Dropdown ref={(ref) => this.handleCloseDropdownNotification = ref}
                                      align="right"
                                      activableComponent={(
                                          <div className="dots-dropdown">
                                              <Icon type="vertical-dots"/>
                                          </div>
                                      )}>
                                <ul className="dropdown-menu">
                                    <Can action={"create"} subject="Reporting">
                                        {!this.props.isMe && <li className="menu-item">
                                            <Report _id={this.props.user._id}
                                                    kind={"users"}
                                                    handleReport={this.handleReport}
                                                    title={this.props.user.username}/>
                                        </li>}</Can>
                                    {!this.props.isMe && <Can action={"isLockUser"} subject={"User"}>
                                        <li className="menu-item"
                                            onClick={() => this.state.isIgnored ? this.handleRemoveIgnoredUser(userId) : this.handleAddIgnoredUser(userId)}>{this.state.isIgnored ? "Débloquer" : "Bloquer"}</li>
                                    </Can>}
                                </ul>
                            </Dropdown>
                        </Can>
                    )}
                    {/*</Fragment>
                    </Breakpoint>*/}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,
        userIgnored: state.userIgnored.data,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createUserIgnored,
    reportUser,
    updateCurrentUser,
    deleteUserIgnored,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfileHeader);
